import {listener} from "../../../../modules/vegas/js/util";
import axios from "axios";

listener('submit', '#form-auth-email', (form, e) => {
	let emailElement = form.querySelector('[name=email]');
	let email = emailElement.value;
	let btn = form.querySelector('button[type=submit]');

	btn.disabled = true;

	let msgError = form.querySelector('.msg-error');

	emailElement.classList.remove('is-invalid');

	axios.post(form.action, new FormData(form))
		.then((response) => {
			emailElement.classList.toggle('is-invalid', response.data.error);
			msgError.innerText = response.data.msg || '';
			msgError.classList.toggle('d-none', !response.data.error);
			btn.disabled = false;

			if (!response.data.error) {
				form.classList.add('d-none');

				let formCode = document.getElementById('form-auth-email-code');
				formCode.classList.remove('d-none');
				formCode.querySelector('[name="email"]').value = email;
			}
		});
}, true);

listener('submit', '#form-auth-email-code', (form, e) => {
	let btn = form.querySelector('button[type=submit]');
	btn.disabled = true;

	let msgError = form.querySelector('.msg-error');

	axios.post(form.action, new FormData(form))
		.then((response) => {
			btn.disabled = false;

			msgError.innerText = response.data.msg || '';
			msgError.classList.toggle('d-none', !response.data.error);

			if (!response.data.error && response.data.redirect_to) {
				location.href = response.data.redirect_to;
			}
		});
}, true);
